import React, { PropTypes, Component } from 'react'
import moment from 'moment-timezone'
import Measure from 'react-measure'

import './AvailabilityCalendar.scss'
import Header from './components/Header'
import Page from 'components/AvailabilityCalendarPage'

class AvailabilityCalendar extends Component {
  constructor (props) {
    super(props)

    this.state = {
      page: 0,
      availability: this.groupAvailabilityByDay(props.availability),
      selectedDate: undefined,
      daysPerPage: 7
    }

    this.onPageChange = this.onPageChange.bind(this)
    this.setDaysPerPage = this.setDaysPerPage.bind(this)
    this.onTimeSelected = this.onTimeSelected.bind(this)
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.availability !== nextProps.availability) {
      const availability = this.groupAvailabilityByDay(nextProps.availability)
      this.setState({ availability })
    }
  }

  setDaysPerPage (dimensions) {
    const dayWidth = 80
    const maxDaysPerPage = 7

    const daysPerPage = Math.min(Math.floor(dimensions.width / dayWidth), maxDaysPerPage)

    this.setState({daysPerPage})
  }

  groupAvailabilityByDay (availability) {
    const { showUnavailableDays } = this.props

    let result = {}

    for (let datetime in availability) {
      const day = datetime.split('T')[0]
      const newDay = !(day in result)

      if (newDay) {
        result[day] = {
          date: moment(day),
          availability: []
        }
      }

      const available = availability[datetime]

      if (available || showUnavailableDays) {
        result[day].availability.push({
          date: moment(datetime),
          available
        })
      }
    }

    return result
  }

  onPageChange (newPage) {
    this.setState({ page: newPage })
  }

  onTimeSelected (date) {
    this.setState({ selectedDate: date })
    this.props.onChange(date)
  }

  render () {
    const {
      page,
      availability,
      selectedDate,
      daysPerPage
    } = this.state

    return (
      <Measure
        whitelist={['width']}
        onMeasure={this.setDaysPerPage}
        >
        <div className='AvailabilityCalendar'>
          <Header
            availability={availability}
            page={page}
            daysPerPage={daysPerPage}
            onPageChange={this.onPageChange}
            />

          <Page
            availability={availability}
            page={page}
            daysPerPage={daysPerPage}
            selectedDate={selectedDate}
            onChange={this.onTimeSelected}
            />
        </div>
      </Measure>
    )
  }
}

AvailabilityCalendar.displayName = 'AvailabilityCalendar'
AvailabilityCalendar.propTypes = {
  availability: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  showUnavailableDays: PropTypes.bool
}
AvailabilityCalendar.defaultProps = {
  showUnavailableDays: false
}

export default AvailabilityCalendar



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/AvailabilityCalendar/AvailabilityCalendar.js